<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="FileIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="viewDetailsReport(params)"
      title="View Details"
    />
  </div>
</template>
  
  <script>
import Swal from "sweetalert2";
import { bus } from "../../../../main";

export default {
  name: "CellRendererActions",
  data() {
    return {};
  },
  methods: {
    viewDetailsReport(params){
      bus.$emit("viewDetails", params);
    }
  },
};
</script>
  